import React from 'react';
import PropTypes from 'prop-types';
import { FormControl, TextField, FormHelperText } from '@mui/material';
import { useFormValidator } from 'react-form-context-validation';

export default function TextInput(props) {
  const { placeholder, value, onChange, required, tabIndex, label, className, type = 'text', onBlur, id, disabled, error = false, rows, variant } = props;
  const inputError = useFormValidator((required && !value) || error, id);

  return (
    <FormControl fullWidth className={className}>
      <TextField
        label={label}
        type={type}
        placeholder={placeholder}
        value={value != null ? value : ''}
        onChange={(e) => onChange(e.target.value)}
        onBlur={onBlur}
        required={required}
        tabIndex={tabIndex}
        disabled={disabled}
        error={!!inputError}
        multiline={!!rows}
        rows={rows}
        variant={variant}
        inputProps={{
          sx: {
            fontFamily: 'Source Sans Pro',
          },
        }}
        InputLabelProps={{
          sx: {
            fontFamily: 'Source Sans Pro',
          },
        }}
      />
      {typeof error === 'string' && (
        <FormHelperText error={true}>
          {error}
        </FormHelperText>
      )}
    </FormControl>
  );
}

TextInput.propTypes = {
  id: PropTypes.string,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  type: PropTypes.oneOf(['password', 'text', 'number']),
  tabIndex: PropTypes.number,
  disabled: PropTypes.bool,
  label: PropTypes.string,
  className: PropTypes.string,
  onBlur: PropTypes.func,
  error: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool,
  ]),
  rows: PropTypes.number,
  variant: PropTypes.oneOf(['standard', 'filled', 'outlined']),
}
